export default "__VITE_ASSET__58499736__"